import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import { clone } from 'ramda'

import ChildrenActions, { ChildrenRedux, ChildrenTypes, Selectors } from '../../Redux/ParentPlatform/ChildrenRedux'
import { notificationSuccess, notificationFail } from '../../Redux/NotificationActions'

const childrenCRUDObservable = createCRUDObservable({
  mainRedux: ChildrenRedux,
  reduxPath: 'parent_platform_children',
  dataHandlers: {
    get: response => response.data,
  },
})

const setActiveChildEpic = action$ => (
  action$.ofType(ChildrenTypes.getSuccess)
    .map(({ results }) => (
      ChildrenActions.setActiveChildId(results[0].id)
    ))
)

const getProfileEpic = (action$, store, { Api }) => (
  action$.ofType(ChildrenTypes.getProfileRequest)
    .mergeMap(({ childId }) => (
      Observable
        .fromPromise(Api.parent_platform_children.getProfile(childId)
          .then(response => response)
          .catch(err => err))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [ChildrenActions.getProfileError(response.error)]
          }
          const { data: { data } } = response
          return [
            ChildrenActions.getProfileSuccess(data)
          ]
        })
    ))
)

const getStudentActivitiesEpic = (action$, store, { Api }) => (
  action$.ofType(ChildrenTypes.getActivitiesRequest)
    .mergeMap(({ studentId, query }) => (
      Observable
        .fromPromise(Api.studentProfile.getActivities(studentId, query)
          .then(response => response)
          .catch(err => err))
        .flatMap((response) => {
          const { status } = response

          if (!(status >= 200 && status < 300)) {
            return [ChildrenActions.getActivitiesError(response.error)]
          }

          const { data } = response

          const state = store.getState()
          const parentChildren = clone(state.parent_platform_children.get.results)
          const { activeChildIndex, student } = clone(Selectors.activeChild(state))

          if (student) {
            if (!student.recent_activities) {
              student.recent_activities = []
            }

            student.recent_activities.push(data)
          }

          if (activeChildIndex >= 0) {
            parentChildren[activeChildIndex] = student
          } else {
            parentChildren.push(student)
          }

          return [
            ChildrenActions.getActivitiesSuccess(parentChildren),
          ]
        })
    ))
)

const checkInEpic = (action$, store, { Api }) => (
  action$.ofType(ChildrenTypes.checkRatingRequest)
    .mergeMap(({ childId, data }) => (
      Api.parent_platform_children.checkIn(childId, data)
        .then(response => response.data.data)
        .catch(err => err)
    ))
    .mergeMap((result) => {
      if ('error' in result) {
        return [ChildrenActions.checkInError(result), notificationFail('Accion Fallida')]
      }
      return [ChildrenActions.checkInSuccess(result), notificationSuccess('Accion Exitosa')]
    })
)

const updateStudentEpic = (action$, store, { Api }) => (
  action$.ofType(ChildrenTypes.updateStudentRequest)
  .mergeMap(({ activeStudentId, profile, timestamp }) => (
      Observable
      .fromPromise(Api.parent_platform_children
          .update(activeStudentId, profile, timestamp)
          .then(response => response)
          .catch(err => err))
      .flatMap((response) => {
          const { status } = response

          if (!(status >= 200 && status < 300)) {
              return [ChildrenActions.updateStudentFailed(response.error),
                  notificationFail(`Proceso fallido (${response.error})`),
              ]
          }

          const { data: { data } } = response

          if (profile.classroom_id) {
              return [
                  ChildrenActions.updateStudentSuccess(data),
                  // ClassroomActions.setActiveClassroomId(profile.classroom_id),
                  notificationSuccess(`Actualización exitosa (${data.first_name})`),
              ]
          }

          return [
            ChildrenActions.updateStudentSuccess(data),
              notificationSuccess(`Actualización exitosa (${data.first_name})`),
          ]
      })
  ))
)

export const childrenObservers = Object.assign({}, childrenCRUDObservable.observers, {})
export const childrenEpic = combineEpics(
  checkInEpic,
  childrenCRUDObservable.epic,
  getProfileEpic,
  getStudentActivitiesEpic,
  setActiveChildEpic,
  updateStudentEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/ParentPlatform/ChildrenObserver.js